export class PasswordChange {
    constructor(
        public passwordOld: string,
        public passwordNew1: string,
        public passwordNew2: string
    ) {
    }
}
